import { render, staticRenderFns } from "./config-list.vue?vue&type=template&id=d587f198&scoped=true&"
import script from "./config-list.vue?vue&type=script&lang=js&"
export * from "./config-list.vue?vue&type=script&lang=js&"
import style0 from "./config-list.vue?vue&type=style&index=0&id=d587f198&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d587f198",
  null
  
)

export default component.exports